<template>
	<div class="learner_program_requirment">

		<div class="row">
      <div class="col-12">
        <template v-if="program">
          <b-card class="text-center prog-req">

						<template #header>
							<div class="hd_ic">
								<div class="ic ic22-dashboard1"></div>
							</div>
        			<div class="hd_txt">
								My Program Status
							</div>
      			</template>

						<div class="crd_content">

							<b-card-text>
	              <div class="program_status_select_bx">
									<div class="selected_val">
	                  <div class="val in_progress" v-if="enrollmentStatus === 'INPROGRSS'">In Progress</div>
	                  <div class="val completed" v-if="enrollmentStatus === 'COMPLETED'">Completed</div>
	                  <div class="val not_complete" v-if="enrollmentStatus === 'NOTCOMPLETED'">Couldn't Complete</div>
	              </div>
              </div>
	            </b-card-text>

						</div>

						<div class="lnk_container">
							<a href="javascript://" @click="navigateToRequirements">Requirements</a>
						</div>

					</b-card>
        </template>
        <template v-else>
          <b-card class="text-center prog-lmi">

						<template #header>
							<div class="hd_ic">

							</div>
        			<div class="hd_txt">
								My Program Status
							</div>
      			</template>

						<div class="crd_content">
	            <b-card-text>
	              <div class="mt-5">
	                <span>Program requirement data not available.</span>
	              </div>
	            </b-card-text>
						</div>

						<div class="lnk_container">

						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapState,mapActions } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-program-requirement',
    props: ['program'],
    data: () => {
      return {
        enrollmentStatus: 'NOTENROLLED',
      }
    },
  async mounted () {
  	await this.getEnrollmentStatus()
  },

  computed: {
    ...mapState({
      'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
    })

    },

		methods: {
			...mapActions([
	      'loadSaveEnrollmentStatus'
	    ]),
			navigateToRequirements () {
        let routerParams = {
          cipCode: this.program.cipCode,
          programGuideCode: this.program.code,
          type: this.program.type,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideDegreeRequirements', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      getEnrollmentStatus (){
      	let status = 'NOTENROLLED'
      	this.learnerEnrollmentData.forEach(obj => {
        	if (obj.programCode === this.program.code) {
          	status = obj.status
        	}
      	})
      	this.enrollmentStatus = status
      },
      roundedValue (value, precision) {
        let multiplier = Math.pow(10, precision || 1)
        let rounded = Math.round(value * multiplier) / multiplier
        return rounded.toFixed(precision || 1)
      }
		}
	}
</script>

<style scoped>
  .prog-req .card-header {
    height: 65px;
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramRequirement.vue